export default __webpack_public_path__ + "static/banner_recruit-fb2c6cab82e53f03ff716f18ec45fd6d.png";